import React from 'react';

export default function WaterGlassLoader({ color = '#1A6DB5', size = 1 }) {
  const W = 56 * size;
  const H = 76 * size;
  const B = 3 * size;

  const id = `wgl-${Math.round(size * 100)}`;

  return (
    <>
      <style>{`
        @keyframes ${id}-fill {
          0%   { height: 0; opacity: 0; }
          5%   { opacity: 1; }
          60%  { height: ${H - B * 2}px; }
          75%  { height: ${H - B * 2}px; }
          100% { height: 0; }
        }
        @keyframes ${id}-wave {
          0%, 100% { transform: translateX(${-8 * size}px); }
          50%       { transform: translateX(${8 * size}px); }
        }
        @keyframes ${id}-b1 {
          0%   { transform: translateY(0); opacity: 0.9; }
          60%  { opacity: 0.5; }
          100% { transform: translateY(${-H * 0.85}px); opacity: 0; }
        }
        @keyframes ${id}-b2 {
          0%   { transform: translateY(0); opacity: 0.9; }
          60%  { opacity: 0.5; }
          100% { transform: translateY(${-H * 0.85}px); opacity: 0; }
        }
        @keyframes ${id}-b3 {
          0%   { transform: translateY(0); opacity: 0.9; }
          60%  { opacity: 0.5; }
          100% { transform: translateY(${-H * 0.85}px); opacity: 0; }
        }
      `}</style>

      <div style={{
        width: W, height: H,
        border: `${B}px solid ${color}`,
        borderRadius: 6 * size,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'flex-end',
      }}>
        {/* Water body */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: color + '40',
          animation: `${id}-fill 3400ms ease-in-out infinite`,
          overflow: 'hidden',
        }}>
          {/* Bubbles */}
          {[
            { left: W * 0.25, delay: '0.2s', anim: `${id}-b1` },
            { left: W * 0.55, delay: '0.7s', anim: `${id}-b2` },
            { left: W * 0.75, delay: '1.3s', anim: `${id}-b3` },
          ].map((b, i) => (
            <div key={i} style={{
              position: 'absolute',
              bottom: 6 * size,
              left: b.left - 3 * size,
              width: 6 * size,
              height: 6 * size,
              borderRadius: '50%',
              backgroundColor: color + 'CC',
              animation: `${b.anim} 1100ms ease-out infinite`,
              animationDelay: b.delay,
            }} />
          ))}

          {/* Wave surface */}
          <div style={{
            position: 'absolute',
            top: -7 * size,
            left: -16 * size,
            right: -16 * size,
            height: 14 * size,
            borderRadius: 7 * size,
            backgroundColor: color + '70',
            animation: `${id}-wave 1400ms ease-in-out infinite`,
          }} />
        </div>
      </div>
    </>
  );
}
